import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { hasSession } from '../lib/auth-client.js'
import { useBranding } from '../lib/branding.js'
import { MarketingNav } from '../components/MarketingNav.js'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async () => {
    if (await hasSession()) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  const { branding } = useBranding()
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <MarketingNav variant="auth" />

      {/* Soft accent backdrop behind the card to echo the landing page hero. */}
      <main className="flex-1 flex items-start md:items-center justify-center px-6 py-12 md:py-20 bg-gradient-to-b from-surface to-surface-muted">
        <div className="w-full max-w-md">
          <div className="rounded-lg border border-border bg-surface shadow-sm p-8">
            <Outlet />
          </div>
          <p className="mt-6 text-center text-xs text-fg-subtle">
            {branding
              ? `${branding.name} · powered by Brightstars`
              : 'For coaching academies'}
          </p>
        </div>
      </main>
    </div>
  )
}
